<template>
  <div>
    <v-btn color="primary" @click="dialog = true">Extender pantalla</v-btn>
    <!-- <v-btn text color="primary" @click="dialogPersonalizacion = true">
      <v-icon left>mdi-palette</v-icon>
      Personalizar Reporte
    </v-btn> -->

    <!-- UNA sola instancia -->
    <ScoreCard :show-filters="!dialog" :fullscreen="dialog" :reporte-preferencias="reporteUsuarioConfig"
      @close="dialog = false" />

    <!-- Oscurecer fondo cuando está en fullscreen -->
    <v-overlay :value="dialog" opacity="0.6" :z-index="2000" />

    <v-dialog v-model="dialogPersonalizacion" persistent width="auto">
      <v-card>
        <v-card-title>
          Personalización de reporte
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- <DialogScorecardPersonalizado v-model="dialogPersonalizacion" :data-json="json" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import ScoreCard from '../Reportes/ReportesOEE/ScoreCard.vue';
import ScoreCard from '@/components/DashViews/Reportes/ReportesOEE/ScoreCard.vue'
// import DialogScorecardPersonalizado from '../Reportes/DashboardAgrupado/DialogScorecardPersonalizado.vue';

export default {
  components: {
    ScoreCard,
    // DialogScorecardPersonalizado,
  },
  data() {
    return {
      dialog: false,
      dialogPersonalizacion: false,
      json: {
        "periodo": {
          "desde": "2025-09-01T07:00:00Z",
          "hasta": "2025-09-24T07:00:00Z",
          "horaCorte": "07:00"
        },
        "resumen": {
          "disponibilidad": 0.92,
          "eficiencia": 0.88,
          "calidad": 0.985,
          "oee": 0.80
        },
        "detallesMaquinas": [
          {
            "idMaquinaIns": 101,
            "nombre": "SF-32",
            "totalPiezas": 12500,
            "piezasOk": 12200,
            "piezasNoOk": 300,
            "disponibilidad": 0.89,
            "eficiencia": 0.84,
            "calidad": 0.976,
            "oee": 0.73
          },
          {
            "idMaquinaIns": 102,
            "nombre": "TRAUB 42",
            "totalPiezas": 9800,
            "piezasOk": 9625,
            "piezasNoOk": 175,
            "disponibilidad": 0.93,
            "eficiencia": 0.86,
            "calidad": 0.982,
            "oee": 0.79
          },
          {
            "idMaquinaIns": 103,
            "nombre": "QUICK 60",
            "totalPiezas": 7600,
            "piezasOk": 7440,
            "piezasNoOk": 160,
            "disponibilidad": 0.91,
            "eficiencia": 0.79,
            "calidad": 0.979,
            "oee": 0.70
          },
          {
            "idMaquinaIns": 104,
            "nombre": "MIGY",
            "totalPiezas": 5600,
            "piezasOk": 5405,
            "piezasNoOk": 195,
            "disponibilidad": 0.87,
            "eficiencia": 0.74,
            "calidad": 0.965,
            "oee": 0.62
          },
          {
            "idMaquinaIns": 105,
            "nombre": "APEKA",
            "totalPiezas": 4200,
            "piezasOk": 4075,
            "piezasNoOk": 125,
            "disponibilidad": 0.85,
            "eficiencia": 0.71,
            "calidad": 0.970,
            "oee": 0.59
          },
          {
            "idMaquinaIns": 106,
            "nombre": "KAVA",
            "totalPiezas": 1500,
            "piezasOk": 1470,
            "piezasNoOk": 30,
            "disponibilidad": 0.95,
            "eficiencia": 0.90,
            "calidad": 0.980,
            "oee": 0.84
          },
          {
            "idMaquinaIns": 107,
            "nombre": "VF-2",
            "totalPiezas": 0,
            "piezasOk": 0,
            "piezasNoOk": 0,
            "disponibilidad": null,
            "eficiencia": null,
            "calidad": null,
            "oee": null
          }
        ]
      },
      reporteUsuarioConfig: {
        reporteNombre: "Scorecard",
        configNombre: "Configuración Base",
        tipoOee: 2, // 1 = Con disponibilidad, 2 = Sin disponibilidad
        configActivo: true,
        configId: 1,
        metricasConfig: [
          {
            id: 1,
            orden: 1,
            nombre: "Disponibilidad",
            tituloTamanio: 18,
            textoTamanio: 15,
            ocultable: false,
            oculto: false,
            color: "#2ED573",
            colorFondo: "#E9FBF1",
            rellenado: "resumen.disponibilidadPromedio",
            icono: "mdi-clock-outline"
          }, {
            id: 2,
            orden: 2,
            nombre: "Eficiencia",
            tituloTamanio: 18,
            textoTamanio: 15,
            ocultable: false,
            oculto: false,
            color: "#7CD1F9",
            colorFondo: "#EEF8FF",
            rellenado: "resumen.eficienciaPromedio",
            icono: "mdi-run"
          }, {
            id: 3,
            orden: 3,
            nombre: "Calidad",
            tituloTamanio: 18,
            textoTamanio: 15,
            ocultable: false,
            oculto: false,
            color: "#FF7CA3",
            colorFondo: "#FFE9F1",
            rellenado: "resumen.calidadPromedio",
            icono: "mdi-star-circle-outline"
          }, {
            id: 4,
            orden: 4,
            nombre: "OEE",
            tituloTamanio: 18,
            textoTamanio: 15,
            ocultable: false,
            oculto: false,
            color: "#F5A623",
            colorFondo: "#FFF4E5",
            rellenado: "resumen.oeePromedio",
            icono: "mdi-chart-bar-stacked"
          },
        ],
        parosConfig: {
          tituloTamanio: 15,
          tituloPorcentajeTamanio: 12,
          cols: 6,
          coloresHex: { prog: '#3F51B5', noProg: '#FB8C00' },
        },
        noOkConfig: {
          cols: 6,
        },
        datosPorMaquinaConfig: {
          cols: 12,
          colorRules: [
            { label: '≤ 20%', from: 0, to: 30, color: '#111827' },
            { label: '>20% y <50%', from: 30.01, to: 69.99, color: '#EF4444' },
            { label: '>70% y <90%', from: 70, to: 89.00, color: '#F59E0B' },
            { label: '≥ 90%', from: 90, to: 1000000000, color: '#10B981' },
          ],
          label: {
            fontPx: 13,        // tamaño del texto
            fontWeight: 600,   // grosor
            inside: true,      // texto dentro de la barra (false = afuera)
            defaultColor: '#111827',
            box: true,
            boxColor: "#000",
          },
          barPx: 42,
          minHeight: 220
        },
      }
    }
  },
  mounted() {
    if(this.nombreEmpresa == "NYX") {
      this.reporteUsuarioConfig.tipoOee = 2;
    } else {
      this.reporteUsuarioConfig.tipoOee = 1;
    }
  },
  computed: {
    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
    }),
  }
}
</script>